export default __webpack_public_path__ + "static/media/team-foto4.81c73690.png";